/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { MigrateCompanyManagerProcessResponse } from './';
import {
    MigrateCompanyManagerProcessResponseFromJSON,
    MigrateCompanyManagerProcessResponseFromJSONTyped,
    MigrateCompanyManagerProcessResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface MigrateCompanyManagersResponse
 */
export interface MigrateCompanyManagersResponse {
    /**
     * 
     * @type {number}
     * @memberof MigrateCompanyManagersResponse
     */
    acceptedCounter: number;
    /**
     * 
     * @type {Array<MigrateCompanyManagerProcessResponse>}
     * @memberof MigrateCompanyManagersResponse
     */
    lineResults: Array<MigrateCompanyManagerProcessResponse>;
}

/**
 * Check if a given object implements the MigrateCompanyManagersResponse interface.
 */
export function instanceOfMigrateCompanyManagersResponse(value: object): value is MigrateCompanyManagersResponse {
    if (!('acceptedCounter' in value) || value['acceptedCounter'] === undefined) return false;
    if (!('lineResults' in value) || value['lineResults'] === undefined) return false;
    return true;
}

export function MigrateCompanyManagersResponseFromJSON(json: any): MigrateCompanyManagersResponse {
    return MigrateCompanyManagersResponseFromJSONTyped(json, false);
}

export function MigrateCompanyManagersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateCompanyManagersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedCounter': json['acceptedCounter'],
        'lineResults': ((json['lineResults'] as Array<any>).map(MigrateCompanyManagerProcessResponseFromJSON)),
    };
}

export function MigrateCompanyManagersResponseToJSON(value?: MigrateCompanyManagersResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'acceptedCounter': value['acceptedCounter'],
        'lineResults': ((value['lineResults'] as Array<any>).map((v) => MigrateCompanyManagerProcessResponseToJSON(v))),
    };
}

